const menuToggle = document.querySelector(".menu-toggle") || "";
const menuWrapper = document.querySelector(".category-menu-wrapper") || "";

function insightsNavigation() {
	// Select all menu items that have a dropdown menu

	// Add event listeners for click and keyboard
    menuToggle.querySelector("a").addEventListener("click", openToggleMenu);
    menuToggle.querySelector("a").addEventListener("keyup", dropdownKeyupHandler);
    menuToggle.querySelector("a").addEventListener("keydown", dropdownKeydownHandler);
}
if(menuToggle !== "") {
    insightsNavigation();
}

// Open dropdown menuu
function openToggleMenu() {
	if (menuWrapper.classList.contains("open-toggle")) {
		event.preventDefault();
		menuWrapper.classList.remove("open-toggle");
		menuWrapper.setAttribute("aria-expanded", "false"); // Indicates to screen readers that a collapsible area is closed
	} else {
		event.preventDefault();
		menuWrapper.classList.add("open-toggle");
		menuWrapper.setAttribute("aria-expanded", "true"); // Indicates to screen readers users that a collapsible area is opened
	}
}

// If spacebar or enter is pressed, open the dropdown
function dropdownKeydownHandler(event) {
	if (event.keyCode === 32 || event.keyCode === 13) {
		event.preventDefault();
		this.click();
	}
}

// If the spacebar is pressed, don't scroll the page
function dropdownKeyupHandler(event) {
	if (event.keyCode === 32) {
		event.preventDefault();
	}
}

export { insightsNavigation };